var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockIcon = function SvgLockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.5V7.5H10V4.5C10 2.85 8.65 1.5 7 1.5C5.35 1.5 4 2.85 4 4.5V7.5H2.5V4.5C2.5 2.025 4.525 0 7 0C9.475 0 11.5 2.025 11.5 4.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.55 18H1.45C0.775 18 0.25 17.475 0.25 16.8V8.7C0.25 8.025 0.775 7.5 1.45 7.5H12.55C13.225 7.5 13.75 8.025 13.75 8.7V16.8C13.75 17.475 13.225 18 12.55 18Z",
    fill: "currentColor"
  })));
};
export default SvgLockIcon;